"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@eig-builder/core-ui/Grid"));

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

var _useLocalStorage3 = _interopRequireDefault(require("@eig-builder/core-utils/hooks/useLocalStorage"));

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var _rowKebabMenu = _interopRequireDefault(require("../row-kebab-menu"));

var _dataGridContext = _interopRequireDefault(require("../../../data-grid-context"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _get = _interopRequireDefault(require("lodash/get"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var search = (0, _debounce["default"])(function (datasource, query) {
  datasource === null || datasource === void 0 ? void 0 : datasource.getRows({
    request: {
      endRow: 0,
      startRow: 0
    },
    parentNode: {
      context: {
        query: query
      }
    },
    successCallback: function successCallback() {}
  });
}, 500);

var CustomView = function CustomView(_ref) {
  var customView = _ref.customView,
      gridSize = _ref.gridSize,
      headers = _ref.headers,
      rowData = _ref.rowData,
      onClickFunc = _ref.onClickFunc,
      getKebabMenuOptions = _ref.getKebabMenuOptions,
      disableGrid = _ref.disableGrid,
      getKebabMenuLoader = _ref.getKebabMenuLoader,
      serverSidePagination = _ref.serverSidePagination,
      datasource = _ref.datasource;

  var _useContext = (0, _react.useContext)(_dataGridContext["default"]),
      showCards = _useContext.showCards,
      searchQuery = _useContext.searchQuery,
      filters = _useContext.filters,
      pageData = _useContext.pageData;

  var _useLocalStorage = (0, _useLocalStorage3["default"])("TOTAL_CARDS".concat(window.location.pathname), []),
      _useLocalStorage2 = (0, _slicedToArray2["default"])(_useLocalStorage, 2),
      loadingItems = _useLocalStorage2[0],
      setItems = _useLocalStorage2[1];

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      queryableProperties = _useState2[0],
      setQueryableProperties = _useState2[1];

  var isMobile = (0, _useResponsiveQuery.useIsMobile)();
  var filteredData = filters ? filters.query(rowData) || pageData : rowData || pageData;
  var spacing = isMobile ? 0 : 6;
  (0, _react.useEffect)(function () {
    if (filteredData && filteredData.length !== loadingItems.length) {
      setItems(filteredData);
    }
  }, [filteredData, loadingItems.length, setItems]);
  (0, _react.useEffect)(function () {
    setQueryableProperties(headers.flatMap(function (_ref2) {
      var enableFilter = _ref2.enableFilter,
          field = _ref2.field;
      return enableFilter ? [field] : [];
    }));
  }, [headers]);
  (0, _react.useEffect)(function () {
    if (searchQuery && serverSidePagination) {
      search(datasource, searchQuery);
    }
  }, [searchQuery]);
  var getEditMenu = (0, _react.useCallback)(function (item) {
    if (getKebabMenuLoader) {
      var loader = getKebabMenuLoader(item);

      if (loader) {
        return loader;
      }
    }

    var menuOptions = item && getKebabMenuOptions(item);

    if (!menuOptions) {
      return null;
    }

    var filteredOptions = menuOptions.filter(function (option) {
      return !option.hidden;
    }); // If there are no menu options, don't show kebabmenu

    if (filteredOptions.length === 0) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement(_rowKebabMenu["default"], {
      item: item,
      menuIdentifier: item && item.id,
      options: filteredOptions
    });
  }, [getKebabMenuLoader]);
  var upperCaseSearchQuery = !(0, _isEmpty["default"])(searchQuery) && searchQuery.toUpperCase();
  var anyQueryablePropertyMatchesSearchQuery = (0, _react.useCallback)(function (item) {
    if ((0, _isEmpty["default"])(searchQuery) || serverSidePagination) {
      return true;
    }

    return queryableProperties.reduce(function (accumulator, queryableProperty) {
      var property = (0, _get["default"])(item, queryableProperty);

      if (property == null || typeof property !== 'string') {
        return accumulator;
      }

      return accumulator || property.toUpperCase().includes(upperCaseSearchQuery);
    }, false);
  }, [upperCaseSearchQuery, queryableProperties]);
  var withContainer = (0, _react.useCallback)(function (items, itemRenderCallback) {
    return disableGrid ? items.map(itemRenderCallback) : /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      container: true,
      spacing: spacing,
      className: "mt-md-3"
    }, items.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], (0, _extends2["default"])({
        item: true
      }, gridSize, {
        key: index
      }), itemRenderCallback(item, index));
    }));
  }, [disableGrid, gridSize, spacing]);
  var DisplayCustomView = customView;
  return showCards && DisplayCustomView && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, filteredData ? (0, _isEmpty["default"])(filteredData) ? withContainer([null], function (item) {
    return /*#__PURE__*/_react["default"].createElement(DisplayCustomView, {
      empty: true,
      item: item
    });
  }) : withContainer(filteredData.filter(anyQueryablePropertyMatchesSearchQuery), function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(DisplayCustomView, {
      item: item,
      index: index,
      onClick: onClickFunc,
      kebabMenu: getEditMenu(item)
    });
  }) : DisplayCustomView.Placeholder ? withContainer(loadingItems, function () {
    return /*#__PURE__*/_react["default"].createElement(DisplayCustomView.Placeholder, null);
  }) : /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null));
};

CustomView.propTypes = {
  customView: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  getKebabMenuOptions: _propTypes["default"].func,
  getPreferedOption: _propTypes["default"].func,
  gridSize: _propTypes["default"].shape({
    xs: _propTypes["default"].number,
    sm: _propTypes["default"].number,
    md: _propTypes["default"].number,
    lg: _propTypes["default"].number,
    xl: _propTypes["default"].number
  }),
  gridData: _propTypes["default"].object,
  onClickFunc: _propTypes["default"].func.isRequired,
  rowData: _propTypes["default"].array.isRequired,
  headers: _propTypes["default"].array.isRequired,
  disableGrid: _propTypes["default"].bool,
  getKebabMenuLoader: _propTypes["default"].func,
  serverSidePagination: _propTypes["default"].bool,
  datasource: _propTypes["default"].object
};
CustomView.defaultProps = {
  gridSize: {
    xs: 12,
    sm: 6,
    md: 6,
    lg: 4,
    xl: 4
  },
  disableGrid: false
};
var _default = CustomView;
exports["default"] = _default;